<script>
    
    export let currentCount;
    export let image;
    export let title;
    export let perpack;
    export let goodId;
    export let totalPrice;
    export let total = 0;
    export let item = {};
    export let counttext = '';
    export let unit = '';
    let totalprices = item.packs.length-1;
    let currentPrice = item.packs[0].price;





    total = perpack * item.packs[0].price * currentCount + parseFloat(totalPrice);

item.packs.forEach((element, key) => {
            element.current = false;
            if( total >= element.min && total < element.max ){
                currentPrice = element.price; 
                item.packs[key].current = true;
            }
        });
console.log(unit);
console.log(currentPrice);

    const priceCounter = () => {
        
        
        total = perpack * item.packs[0].price * currentCount + parseFloat(totalPrice);

        console.log('totalPrice = ',totalPrice);
        console.log('perpack = ',perpack);
        console.log('item.packs[0].price = ',item.packs[0].price);
        console.log('currentCount = ',currentCount);
        console.log('total = ',total);

        item.packs.forEach((element, key) => {
            element.current = false;
            if( total >= element.min && total < element.max ){
                currentPrice = element.price; 
                //total = perpack * currentPrice * currentCount + parseFloat(totalPrice);
                item.packs[key].current = true;
            }
        });
        
        
    }
    
    function buyButton(){
        let params={
            type:2,
            price1:item.packs[0].price.toFixed(2),
            price2:item.packs[1].price.toFixed(2),
            price3:item.packs[2].price.toFixed(2),
            min_zakaz:perpack
        }; 
        
        basket.add(goodId,currentCount,params);
        totalPrice=totalPrice+item.packs[0].price*currentCount;
    }
</script>

<div class="mx_checkout">

    <div class="left_side">
        <span>Товар</span>
        <div class="item_wrapper">
            <div class="img_wrapper">
                <img src={image} alt="">
            </div>
            <div class="description">
                <p>{title}</p>
            </div>
            <div class="minsize">
                Минимальный заказ: {unit} {perpack} {counttext}.
            </div>
            
        </div>
    </div>

    <div class="middle_side">
        <ul class="priceTable">
        
            {#each item.packs as item, index}
                <li class:current={item.current}>
                    {#if index == totalprices}
                        <span>от {item.min} ₽</span>
                    {:else if index==0}
                        <span>до {item.max} ₽</span>
                    {:else}
                        <span>от {item.min} до {item.max} ₽</span>
                    {/if}
                    
                    <div class="priceperpage">{item.price} ₽</div>
            </li>
            {/each}
        </ul>
    </div>

    <div class="right_side">
        <div class="input_range_wrapper">
            <div class="iw">
                <button on:click= {()=>{if(currentCount<=1){currentCount=1}else{currentCount--};priceCounter();}} >-</button>
                <input type="text" on:keydown={priceCounter} on:keyup={priceCounter} bind:value={currentCount}>
                <button on:click= {()=>{currentCount++;priceCounter();}} >+</button>
            </div>
            <button on:click={buyButton}>купить</button>
        </div>
    </div>

    <div class="bottom_side">
        <div class="ls"><span>{currentCount} товар на сумму: </span><div class="inprice">{(currentCount * perpack * currentPrice ).toFixed(2)}₽</div></div>
        <div class="rs"><span>Общая сумма корзины: </span><div class="inprice">{ total }₽</div></div>
        
    </div>
</div>




<style lang="scss">
    .input_range_wrapper{
        position: relative;
        background: #FF0A0B;
        display: flex;
        border-radius: 40px;
        border:3px solid #FF0A0B;
            .iw{
                display: flex;
                position: relative;
                margin-right: 10px;
                button{    
                    position: absolute;
                    z-index: 1;
                    border:none;
                    background: none;
                    width: 25px;
                    padding: 0;
                    margin: 0;
                    height: 100%;
                    color: black;
                    cursor: pointer;
                    &:first-child{
                        left: 0;
                    }
                    &:last-child{
                        right: 0;
                    }
                }
                input{
                    width: 90px;
                    border-radius: 30px;
                    text-align: center;
                    outline: none;
                    margin: 0;
                    border:1px solid #FF0A0B;
                }
            }
            button{
                height: 38px;
                margin: 0;
                padding: 0;
                background: none;
                border:none;
                cursor: pointer;
                color:white;
                margin-right: 15px;
            }
        
    }
    *{
        box-sizing: border-box;
    }
    .mx_checkout{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 1010px;
        position: relative;
        &:after{
                    content: "";
                    position: absolute;
                    width: 100%;
                    height: 2px;
                    left: 50%;
                    top: 42px;
                    transform: translate(-50%,-50%);
                    background: #E7EDF6;
                }
        .left_side{
            width: 28%;
            span{
                height: 40px;
                display: flex;
                align-items: center;
                position: relative;
                margin-bottom: 20px;
                
            }
            .item_wrapper{
                display: flex;
                flex-wrap: wrap;
                .img_wrapper{
                    width:65px;
                    height: 65px;
                    overflow: hidden;
                    flex-shrink: 0;
                    img{
                        width:100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                .description{
                    width:calc(100% - 65px);
                    padding-left: 10px;
                    padding-right: 10px;
                    p{
                        padding: 0;
                        margin: 0;
                        font-size: 14px;
                    }
                }
                .minsize{
                    width: 100%;
                    background: #F0F5F8;
                    color: red;
                    font-weight: bold;
                    font-size: 14px;
                    height:20px;
                    display: flex;
                    padding: 0 10px;
                    margin: 30px 0;
                }
            }
        }
        .right_side{
            display: flex;
            align-items: center;
            justify-content: center;
            width: calc(100% - 28% - 485px);
        }
        .bottom_side{
            background: #E7EEF6;
            padding: 18px 69px;
            font-size: 18px;
            text-transform: uppercase;
            font-weight: bold;
            display: flex;
            position: absolute;
            justify-content: space-between;
            bottom: -45px;
            left: -70px;
            right: -70px;
            .inprice{
                color: red;
                padding-left: 10px;
                display: inline;
            }
        }
    }
        ul{
            display:flex;
            width: 485px;
            height:200px;
            list-style-type: none;
            padding:0;
            margin:0;
            margin-bottom: 40px;
            position: relative;
            overflow: visible;
            *{
                box-sizing: border-box;
            }
            &:after{
                    content: "";
                    position: absolute;
                    width: 100%;
                    height: 10px;
                    left: 50%;
                    top: 42px;
                    transform: translate(-50%, -50%);
                    background: #E7EEF6;
                    border-radius: 40px;
                    z-index: 0;
            }
        }
        ul li{
            padding: 10px;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 40px;
            width:100%;
            font-size: 11px;
            font-weight: bold;
            color: #596b7f;
            .priceperpage{
                position: absolute;
                margin-top: 180px;
                height: 80px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                border-right: 2px solid #E7EEF6;
                font-size: 18px;
                font-weight: bold;
            }
            &.current{
                
                &:before{
                    content: "";
                    position: absolute;
                    width: 100%;
                    height: 10px;
                    left: 0%;
                    bottom: -7px;
                    background: #00A3D9;
                    z-index: 1;
                }

                &:after{
                    content: "Ваша цена";
                    position: absolute;
                    text-align: center;
                    left: 50%;
                    bottom: -43px;
                    padding: 3px 0;
                    width:100%;
                    transform: translate(-50%,0%);
                    border:1px solid #00A3D9;
                    color: #00A3D9;
                    display: flex;
                    background: none;
                    text-transform: uppercase;
                    justify-content: center;
                }
            }
            &:first-child{
                &:before{
                    border-radius: 30px 0px 0px 30px;
                }
            }
            &:last-child{
                &:before{
                    border-radius: 0px 30px 30px 0px;
                }
            }
        }
    
</style>